import { Button, Spinner, Tooltip } from '@coreai/fluentui-react';
import { ArrowRedoRegular } from '@fluentui/react-icons';
import type { ActionResubmitState } from './resubmitEligibility';

type SubmitFromActionButtonProps = {
  state: ActionResubmitState;
  isPending: boolean;
  onSubmit: () => void;
  variant: 'inline' | 'expanded';
};

export const SubmitFromActionButton = ({ state, isPending, onSubmit, variant }: SubmitFromActionButtonProps) => {
  if (!state.visible) return null;
  const isDisabled = state.disabled || isPending;
  return (
    <Tooltip content={state.reason} relationship="description">
      <Button
        appearance="subtle"
        size="small"
        icon={isPending ? <Spinner size="extra-tiny" aria-hidden="true" /> : <ArrowRedoRegular />}
        disabledFocusable={isDisabled}
        onClick={isDisabled ? undefined : onSubmit}
        data-testid={variant === 'expanded' ? 'submit-from-action-expanded' : 'submit-from-action'}
      >
        {isPending ? 'Submitting…' : 'Submit from this action'}
      </Button>
    </Tooltip>
  );
};
